import { render, staticRenderFns } from "./HomeFeedEnd.vue?vue&type=template&id=5d8e2449&scoped=true"
import script from "./HomeFeedEnd.vue?vue&type=script&lang=js"
export * from "./HomeFeedEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8e2449",
  null
  
)

export default component.exports